const Config = {
    apiUrl: 'https://www.omdbapi.com',
    apiKey: '33e650ba'
};

module.exports = Config;